import styled from "@emotion/styled";

export const AuthenticationFormFooter = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
})